// extracted by mini-css-extract-plugin
export default {"input":"InteractiveCircle__input--HdvXs87TRC","input-menu":"InteractiveCircle__input-menu--aHpqqba858"};